import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import FilterHeading from './FilterHeading';
import FavoriteCheckbox from '../Checkbox/FavoriteCheckbox';
import breakpoints from '../Theme/breakpoints';

const FavoritesFilterWrapper = styled.div`
  display: flex;
  margin: 0 -16px 12px 16px;
  @media (min-width: ${breakpoints.md}px) {
    margin: -16px 0 16px;
  }
`;

const FavoritesFilterHeading = styled(FilterHeading)`
  flex: 0 0 auto;
  padding: 16px 16px 16px 0;

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 16px 0 0;
  }
`;

const favoritesFilterPropertyTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  modal: PropTypes.bool,
};

type FavoritesFilterProperties = InferProps<
  typeof favoritesFilterPropertyTypes
> & {
  selected?: boolean;
};

const FavoritesFilter = ({
  title,
  onClick,
  selected = false,
  modal = false,
}: FavoritesFilterProperties) => (
  <FavoritesFilterWrapper className="category-filter">
    <FavoritesFilterHeading tag="h2" modal={modal}>
      { title }
    </FavoritesFilterHeading>
    <FavoriteCheckbox
      onClick={onClick}
      checked={selected}
      checkedColor="var(--primary-color)"
      uncheckedColor="transparent"
      data-testid="favorites-checkbox"
    />
  </FavoritesFilterWrapper>
);

FavoritesFilter.propTypes = favoritesFilterPropertyTypes;

export default FavoritesFilter;
